import { Box, Paper, Typography } from "@mui/material";

export default function NoAccess() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
      <Paper sx={{ p: 4, maxWidth: 480, textAlign: "center" }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          No access yet
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Your account doesn't have access to any Watershed tabs.
          Contact your administrator to be added to a role group.
        </Typography>
      </Paper>
    </Box>
  );
}
